<template>
  <svg height="153px" version="1.1" viewBox="0 0 202 153" width="202px" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <polygon id="path-1"
               points="23.6453202 112.315271 23.6453202 109.396677 55.3597224 105.01346 51.8103335 86.1720185 72.4063224 81.2159873 71.5005048 62.0856318 87.1036022 54.1871921 88.6699507 56.5759734 74.31912 63.8750221 75.1470963 83.0588549 55.3597224 87.9434022 59.3542631 107.464222"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.2%" id="filter-2" width="107.4%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M140.566328,126.633577 L180.983059,155.487922 C186.061647,148.848647 189.466712,140.876685 190.49314,132.080423 C191.518676,123.284161 190.03571,114.778347 186.614134,107.21206 L140.566328,126.633577"
        id="path-3"></path>
      <filter filterUnits="objectBoundingBox" height="110.1%" id="filter-4" width="109.0%" x="-2.4%" y="-2.9%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="69.4581281" cy="63.0541872" id="path-5" r="19.2118227"></circle>
      <filter filterUnits="objectBoundingBox" height="112.1%" id="filter-6" width="112.1%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M25.089488,81.7515959 L48.8640354,98.8286571 C51.8514406,94.8992907 53.8544197,90.1811903 54.458201,84.9752396 C55.0614574,79.7692888 54.1891246,74.7352351 52.1764325,70.2572286 L25.089488,81.7515959"
        id="path-7"></path>
      <filter filterUnits="objectBoundingBox" height="117.0%" id="filter-8" width="115.2%" x="-4.0%" y="-5.0%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <polygon id="path-9"
               points="82.4580795 72.824423 82.4580795 69.9058295 114.172482 65.5226122 110.623093 46.6811705 131.219082 41.7251393 130.313264 22.5947838 145.916362 14.6963441 147.48271 17.0851254 133.131879 24.3841741 133.959856 43.5680069 114.172482 48.4525542 118.167022 67.9733739"></polygon>
      <filter filterUnits="objectBoundingBox" height="108.2%" id="filter-10" width="107.4%" x="-2.0%" y="-2.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="165.024631" cy="72.4137931" id="path-11" r="11.3300493"></circle>
      <filter filterUnits="objectBoundingBox" height="120.5%" id="filter-12" width="120.5%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="140.314264" cy="126.600985" id="path-13" r="11.3300493"></circle>
      <filter filterUnits="objectBoundingBox" height="120.5%" id="filter-14" width="120.5%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="104.625567" cy="37.9310345" id="path-15" r="11.3300493"></circle>
      <filter filterUnits="objectBoundingBox" height="120.5%" id="filter-16" width="120.5%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="102.955665" cy="75.3694581" id="path-17" r="11.3300493"></circle>
      <filter filterUnits="objectBoundingBox" height="120.5%" id="filter-18" width="120.5%" x="-5.8%" y="-5.8%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M122.33731,76.2624776 L153.244222,98.9000992 C157.127848,93.6912691 159.731721,87.4368808 160.516637,80.5357905 C161.30087,73.6347001 160.166838,66.9614791 157.550338,61.0253631 L122.33731,76.2624776"
        id="path-19"></path>
      <filter filterUnits="objectBoundingBox" height="112.8%" id="filter-20" width="111.7%" x="-3.1%" y="-3.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M148.503479,92.6096489 L181.787846,116.75308 C185.970213,111.197769 188.774384,104.527351 189.619678,97.167214 C190.464236,89.8070767 189.242971,82.6899663 186.425202,76.3589916 L148.503479,92.6096489"
        id="path-21"></path>
      <filter filterUnits="objectBoundingBox" height="112.0%" id="filter-22" width="110.9%" x="-2.9%" y="-3.5%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M151.896377,156.528835 L175.670925,173.605897 C178.65833,169.67653 180.661309,164.95843 181.26509,159.752479 C181.868346,154.546528 180.996014,149.512475 178.983322,145.034468 L151.896377,156.528835"
        id="path-23"></path>
      <filter filterUnits="objectBoundingBox" height="117.0%" id="filter-24" width="115.2%" x="-4.0%" y="-5.0%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <path
        d="M68.225343,97.3114967 L123.699287,137.943125 C130.669899,128.593943 135.343517,117.368118 136.75234,104.981545 C138.159938,92.5949729 136.124495,80.6173967 131.428214,69.9628295 L68.225343,97.3114967"
        id="path-25"></path>
      <filter filterUnits="objectBoundingBox" height="107.2%" id="filter-26" width="106.5%" x="-1.7%" y="-2.1%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="38.4236453" cy="137.931034" id="path-27" r="38.4236453"></circle>
      <filter filterUnits="objectBoundingBox" height="106.0%" id="filter-28" width="106.0%" x="-1.7%" y="-1.7%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="129.094258" cy="154.965532" id="path-29" r="19.2118227"></circle>
      <filter filterUnits="objectBoundingBox" height="112.1%" id="filter-30" width="112.1%" x="-3.4%" y="-3.4%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
      <circle cx="93.9574039" cy="158.660113" id="path-31" r="15.5172414"></circle>
      <filter filterUnits="objectBoundingBox" height="115.0%" id="filter-32" width="115.0%" x="-4.3%" y="-4.3%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="0.320197044"
                      result="shadowSpreadOuter1"></feMorphology>
        <feOffset dx="2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
        <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out"
                     result="shadowOffsetOuter1"></feComposite>
        <feColorMatrix in="shadowOffsetOuter1"
                       type="matrix"
                       values="0 0 0 0 0.00784313725   0 0 0 0 0.0274509804   0 0 0 0 0.22745098  0 0 0 0.05 0"></feColorMatrix>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
      <g id="Group" transform="translate(2.000000, -26.000000)">
        <g id="aktie" transform="translate(2.000000, 0.000000)">
          <g :fill-opacity="calcFillOpacity(9)"
             class="shapes"
             id="Stroke-1-Copy"
             transform="translate(56.157635, 83.251232) scale(-1, 1) rotate(69.000000) translate(-56.157635, -83.251232) "
             v-if="hide(9)">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-1"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(7)"
             class="shapes"
             id="pie-copy-2"
             transform="translate(165.689481, 131.349991) rotate(-56.000000) translate(-165.689481, -131.349991) "
             v-if="hide(7)">
            <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-3"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-3"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(14)" class="shapes" id="Oval-Copy-2" v-if="hide(14)">
            <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-5"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-5"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(10)"
             class="shapes"
             id="pie-copy-3"
             transform="translate(39.867813, 84.542943) rotate(227.000000) translate(-39.867813, -84.542943) "
             v-if="hide(10)">
            <use fill="black" fill-opacity="1" filter="url(#filter-8)" xlink:href="#path-7"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-7"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(15)"
             class="shapes"
             id="Stroke-1-Copy-6"
             transform="translate(114.970395, 43.760384) scale(-1, 1) rotate(39.000000) translate(-114.970395, -43.760384) "
             v-if="hide(15)">
            <use fill="black" fill-opacity="1" filter="url(#filter-10)" xlink:href="#path-9"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-9"></use>
          </g>

          <g :fill-opacity="calcFillOpacity(13)" class="shapes" id="Oval-Copy-2" v-if="hide(13)">
            <use fill="black" fill-opacity="1" filter="url(#filter-12)" xlink:href="#path-11"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-11"></use>
          </g>

          <g :fill-opacity="calcFillOpacity(6)" class="shapes" id="Oval-Copy-9" v-if="hide(6)">
            <use fill="black" fill-opacity="1" filter="url(#filter-14)" xlink:href="#path-13"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-13"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(16)" class="shapes shape-gt75" id="Oval-Copy-10" v-if="hide(16)">
            <use fill="black" fill-opacity="1" filter="url(#filter-16)" xlink:href="#path-15"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-15"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(11)" class="shapes" id="Oval-Copy-14" v-if="hide(11)">
            <use fill="black" fill-opacity="1" filter="url(#filter-18)" xlink:href="#path-17"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-17"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(12)"
             class="shapes"
             id="pie-copy-9"
             transform="translate(141.549133, 79.962731) rotate(-110.000000) translate(-141.549133, -79.962731) "
             v-if="hide(12)">
            <use fill="black" fill-opacity="1" filter="url(#filter-20)" xlink:href="#path-19"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-19"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(8)"
             class="shapes"
             id="pie-copy-8"
             transform="translate(169.193134, 96.556036) rotate(10.000000) translate(-169.193134, -96.556036) "
             v-if="hide(8)">
            <use fill="black" fill-opacity="1" filter="url(#filter-22)" xlink:href="#path-21"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-21"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(4)"
             class="shapes"
             id="pie-copy-3"
             transform="translate(166.674702, 159.320182) rotate(250.000000) translate(-166.674702, -159.320182) "
             v-if="hide(4)">
            <use fill="black" fill-opacity="1" filter="url(#filter-24)" xlink:href="#path-23"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-23"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(5)"
             class="shapes"
             id="pie-copy"
             transform="translate(102.708102, 103.952977) rotate(130.000000) translate(-102.708102, -103.952977) "
             v-if="hide(5)">
            <use fill="black" fill-opacity="1" filter="url(#filter-26)" xlink:href="#path-25"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-25"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(1)" class="shapes" id="Oval" v-if="hide(1)">
            <use fill="black" fill-opacity="0.4" filter="url(#filter-28)" xlink:href="#path-27"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-27"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(3)" class="shapes" id="Oval-Copy" v-if="hide(3)">
            <use fill="black" fill-opacity="1" filter="url(#filter-30)" xlink:href="#path-29"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-29"></use>
          </g>
          <g :fill-opacity="calcFillOpacity(2)" class="shapes" id="Oval-Copy-5" v-if="hide(2)">
            <use fill="black" fill-opacity="1" filter="url(#filter-32)" xlink:href="#path-31"></use>
            <use :fill="fill" fill-rule="evenodd" :stroke="stroke" stroke-width="0.640394089"
                 xlink:href="#path-31"></use>
          </g>
        </g>
        <polyline fill-rule="nonzero" id="Line-2" points="0 127 0.122487437 175 195 175 194.901579 127" stroke="#02073A"
                  stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="4"></polyline>
      </g>
    </g>
  </svg>
</template>

<script>
const ELEMENT_COUNT = 16

export default {
  name: 'finShapesCollectionContainer',
  props: {
    /** the color the shapes are getting filled with */
    fill: {
      type: String,
      default () {
        return this.$finColors.accentYellow
      }
    },
      /** the color of the borders of the shapes */
      stroke: {
          type: String,
          default() {
              return this.$finColors.accentYellow
          }
      },
    /** how many of the 16 shapes should be displayed (as percentage) */
    percentage: {
      type: Number,
      default: 100
    },
    /** how many of the displayed shapes should be marked as used (as percentage) */
    percentageUsed: {
      type: Number,
      default: 50
    },
    /** the percentage to use as 100 */
    fullValue: {
      type: Number,
      default: 100
    }
  },
  computed: {
    visibleElements () {
      return Math.round(ELEMENT_COUNT / this.fullValue * this.percentage)
    },
    filledElements () {
      return Math.round(this.visibleElements / 100 * this.percentageUsed)
    }
  },
  methods: {
    hide (elemIndex) {
      return !(elemIndex > this.visibleElements)
    },
    calcFillOpacity (elemIndex) {
      return elemIndex <= this.filledElements ? 1 : 0.4
    }
  }
}
</script>

<style scoped>

</style>
